export const checkIsUndefinedValue = (value) => {
    if (!value) {
        return;
    }
    return value;
};
